module.exports = __webpack_public_path__ + "static/media/18.a146d8c6.jpg";